let current_fs, next_fs, previous_fs; // fieldsets
let left, opacity, scale; // fieldset properties which will animate
let animating; // flag to prevent quick multi-click glitches

$(".next").click(function(){
  
  let valid = true;

  $form = $( this ).closest( 'form' );
  $fieldset = $( this ).closest( 'fieldset' );

  // validate required fields
  $fieldset.find( '.required' ).each( function() {
    let $this = $( this );
    let id = $this.attr( 'id' );
    let $label = $fieldset.find( 'label[for="' + id + '"]'  );

    $this.removeClass( 'input--error' );
    $label.removeClass( 'red' );

    if( $this.val().trim() === '' ) {
      
      valid = false;
      $this.addClass( 'input--error' );
      $label.addClass( 'red' );

    }
  } );

  // enforce min/max on number inputs
  $fieldset.find( 'input[type="number"]' ).on( 'change', function() {
    let $this = $( this );
    
    if( $this.attr( 'min' ) === undefined && $this.attr( 'max' ) === undefined ) return;

    let min = $this.attr( 'min' );
    if( min !== undefined ) {
      min = parseInt( min, 10 );
      if( $this.val().trim() == '' || parseInt( $this.val(), 10 ) < min ) {
        $this.val( min );
      }
    }

    let max = $this.attr( 'max' );
    if( max !== undefined ) {
      max = parseInt( max, 10 );
      if( parseInt( $this.val(), 10 ) > max ) {
        $this.val( max );
      }
    }

  } );

  if( !valid ) return false;

  if(animating) return false;
  animating = true;

  current_fs = $(this).parent();
  next_fs = $(this).parent().next();

  // show next fs
  next_fs.show();
  
  // hide current fs
  current_fs.animate({ opacity: 0 }, {
    step: function(now, mx) {
      // as opacity of current_fs reduces to 0 - stored in "now"
      
      // 1. scale current_fs down to 80%
      scale = 1 - (1 - now) * 0.2;
      
      // 2. bring next_fs from the right 50%
      left = (now * 50) + "%";
      
      // 3. increase opacity of next_fs to 1 as it moves in
      opacity = 1 - now;
      current_fs.css({
        'transform': 'scale(' + scale + ')', 
        'position': 'absolute'
      });
      
      next_fs.css({ 'left': left, 'opacity': opacity });
    },
    
    duration: 800,
    complete: function() {
      current_fs.hide();
      animating = false;
      
      // this comes from custom easing plugin
      easing: "easeInOutBack"
    }
  })
})

$(".previous").click(function() {
  
  if (animating) return false;
  animating = true;
  
  current_fs = $(this).parent();
  previous_fs = $(this).parent().prev();
  
  // show the prev fs
  previous_fs.show();
  
  // hide the current fieldset with style
  current_fs.animate({ opacity: 0 }, {
    step: function(now, mx) {
      // as the opacity of current_fs reduces to 0 - stored in "now"
      // 1. scale previous_fs from 80% to 100%
      scale = 0.8 + (1 - now) * 0.2;
      
      // 2. take current_fs to the right 50% from 0%
      left = ((1 - now) * 50) + "%";
      
      // 3. increase opacity of previous_fs to 1 as it moves in
      opacity = 1 - now;
      current_fs.css({ 'left': left });
      previous_fs.css({ 
        'transform': 'scale(' + scale + ')', 
        'opacity': opacity,
        'position': 'relative'
      });
    },
    duration: 800,
    complete: function() {
      current_fs.hide();
      animating = false;
      
      // this comes from custom easing plugin
      easing: "easeInOutBack"
    }
  });
});